<script setup>

import { favoritesStore } from "@/stores/favoritesStore.js";
import {onMounted, computed, onUnmounted, ref} from "vue";
import {useRouter} from "vue-router";
import Text from "@/components/common/Text.vue";
import {useI18n} from "vue-i18n";
import { useDisplay } from "vuetify";

const { xs, sm, md } = useDisplay();
const favStore = favoritesStore();
const router = useRouter();
const { t } = useI18n();

const screenWidth = ref(window.innerWidth);

function updateWidth() {
    screenWidth.value = window.innerWidth;
}

onMounted(() => {
    window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
    window.removeEventListener("resize", updateWidth);
});

const limit = computed(() => {
    if (xs.value || sm.value) return 1;

    if (md.value || screenWidth.value < 1730) return 3;

    return 7;
});

const visibleFavorites = computed(() =>
    favStore.favoriteCards.slice(0, limit.value)
);

const extraFavorites = computed(() =>
    favStore.favoriteCards.slice(limit.value)
);

onMounted(async () => {
    await favStore.loadFavorites();
});
</script>
<template>
    <div v-if="favStore.favoriteCards.length" class="favorite-section">
        <div class="favorite-list d-flex align-center gap-2">
            <v-menu>
                <template #activator="{ props }">
                    <v-icon
                        v-bind="props"
                        size="17"
                        class="cursor-pointer font-weight-light ms-2"
                        :title="t('common.labels.manageFavorites')"
                    >
                        mdi-dots-vertical
                    </v-icon>
                </template>

                <v-list min-width="250">
                    <v-list-item to="/manageFavorites">
                        <v-list-item-title>
                            {{ t('common.labels.manageFavorites') }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>


            <div
                v-for="fav in visibleFavorites"
                :key="fav.title"
                class="favorite-item"
                @click="router.push(fav.route)"
            >
                <v-icon size="20" class="fav-icon me-1">{{ fav.icon || 'mdi-star' }}</v-icon>
                <Text tag="span">{{ t(fav.title) }}</Text>
            </div>

            <div v-if="extraFavorites.length">
                <v-menu>
                    <template #activator="{ props }">
                        <div
                            v-bind="props"
                            class="d-flex align-center cursor-pointer text-light"
                            style="gap: 4px;"
                        >
                            <v-icon size="22">mdi-folder</v-icon>
                            <v-icon size="20">mdi-chevron-down</v-icon>
                        </div>
                    </template>

                    <v-list>
                        <v-list-item
                            v-for="fav in extraFavorites"
                            :key="fav.title"
                            @click="router.push(fav.route)"
                        >
                            <v-list-item-title>
                                <v-icon size="20" class="fav-icon me-1">{{ fav.icon || 'mdi-star' }}</v-icon>
                                {{ t(fav.title) }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </div>
    </div>

</template>
<style lang="scss">

.favorite-section {
    position: relative;
    left: 10px;
}

.favorite-list {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.favorite-item {
    display: flex;
    cursor: pointer;
    transition: 0.2s;
}

.favorite-item *:hover {
    color: gold!important;
}

.fav-icon {
    color: gold;
}

.fav-title {
    font-weight: bold;
}
</style>
